import { GetInitialIdListArgument } from 'components/SearchSideBar/types';
import { createPositionsQuery } from 'components/SearchSideBar/logics/createQuery/details/position';

/**
 * id配列を取得
 * @param param.savedSearchCondition 保存した検索条件のレスポンス
 * @param param.featuredSearchCondition 特集枠検索条件のレスポンス
 * @param param.queries クエリパラメータ
 * @returns {string[]} id配列
 */
export const getInitialIdList = ({
  savedSearchCondition,
  featuredSearchCondition,
  queries,
}: GetInitialIdListArgument) => {
  // 保存した検索条件
  if (savedSearchCondition) {
    const idList = savedSearchCondition.positionsList
      ? createPositionsQuery(savedSearchCondition.positionsList)
      : [];

    return idList;
  }

  // 特集枠検索条件
  if (featuredSearchCondition) {
    const idList = featuredSearchCondition.positions
      ? createPositionsQuery(featuredSearchCondition.positions)
      : [];

    return idList;
  }

  // クエリから取得した検索条件
  return queries ?? [];
};
